import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
// import Auth from './components/Auth';
import Calculator from './components/Calculator';

const msalConfig = {
    auth: {
        clientId: 'd9801014-18c2-46ca-a3f4-069d47359869',
        authority: 'https://login.microsoftonline.com/dd5343bd-f2c4-4f9b-8178-8dfb6445911b',
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true
    }
};

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize before rendering
msalInstance.initialize();

const App = () => {
    return (
        <MsalProvider instance={msalInstance}>
            {/* <Auth /> */}
            <Calculator />
        </MsalProvider>
    );
};

export default App; 